export const CHATGPT_MODELS = [
  { id: 'gpt-4', name: 'GPT-4' },
  { id: 'gpt-4-turbo', name: 'GPT-4 Turbo' },
  { id: 'gpt-4o', name: 'GPT-4 Omni' },
  { id: 'gpt-4o-search-preview', name: 'GPT-4o Search Preview' },
  { id: 'gpt-4o-mini-search-preview', name: 'GPT-4o Mini Search Preview' },
  { id: 'gpt-4o-mini', name: 'GPT-4 Omni Mini' },
  { id: 'o1', name: 'OpenAI o1' },
  { id: 'o1-mini', name: 'OpenAI o1 Mini' },
  { id: 'o1-pro', name: 'OpenAI o1 Pro' },
  { id: 'o3-mini', name: 'OpenAI o3 Mini' },
  { id: 'o3-mini-high', name: 'OpenAI o3 Mini High' },
  { id: 'gpt-4.5', name: 'GPT-4.5' },
];

export const YANDEXGPT_MODELS = [
  { id: 'yandexgpt-lite', name: 'YandexGPT Lite' },
  { id: 'yandexgpt', name: 'YandexGPT Pro' },
  { id: 'yandexgpt-32k', name: 'YandexGPT Pro 32k' },
  { id: 'llama-lite', name: 'Llama 8B\u00B2' },
  { id: 'llama', name: 'Llama 70B\u00B2' },
];

export const DEEPSEEK_MODELS = [
  { id: 'deepseek-chat', name: 'DeepSeek-V3' },
  { id: 'deepseek-reasoner', name: 'DeepSeek-R1' },
];

export const GROK_MODELS = [
  { id: 'grok-2', name: 'Grok-2' },
  { id: 'grok-2-vision', name: 'Grok-2 Vision' },
  { id: 'grok-2-image', name: 'Grok-2 Image' },
];

export const SONAR_MODELS = [
  { id: 'sonar-pro', name: 'Sonar Pro' },
  { id: 'sonar', name: 'Sonar' },
  { id: 'sonar-deep-research', name: 'Sonar Deep Research' },
  { id: 'sonar-reasoning-pro', name: 'Sonar Reasoning Pro' },
  { id: 'sonar-reasoning', name: 'Sonar Reasoning' },
];

export const GIGACHAT_MODELS = [
  { id: 'GigaChat-2', name: 'GigaChat 2 Lite' },
  { id: 'GigaChat-2-Pro', name: 'GigaChat 2 Pro' },
  { id: 'GigaChat-2-Max', name: 'GigaChat 2 Max' },
  { id: 'GigaChat', name: 'GigaChat Lite' },
  { id: 'GigaChat-Pro', name: 'GigaChat Pro' },
  { id: 'GigaChat-Max', name: 'GigaChat Max' },
];

export const AI_FREE_YANDEX = 'yandexGpt';
export const AI_GROK = 'grok';
export const AI_DEEPSEEK = 'deepSeek';
export const AI_CHATGPT = 'chatGpt';
export const AI_YANDEX = 'nonFreeYandexGpt';
export const AI_SONAR = 'sonar';
export const AI_GIGACHAT = 'gigaChat';
